"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function RestoreIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M13.406,2.941a9.07,9.07,0,0,0-9.017,8.217L2.737,9.507l-1.2,1.2,3.184,3.184a.852.852,0,0,0,1.2,0l3.184-3.184-1.2-1.2L6.081,11.329a7.357,7.357,0,1,1,7.325,8.03v1.7a9.059,9.059,0,0,0,0-18.118ZM5.32,12.089,5.231,12h.178Z" })));
}
exports.default = RestoreIcon;
